import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { breakpoints, colors, IconSize } from "@/styles/utils/vars";
import { getBoxSize } from "@/ui/Button/helpers";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { cssIcon, getSizeSVG } from "@/ui/Icon";
import { getTypographyBase } from "@/ui/Typography/Typography";
export const cssIsAdditionalLoad = "cssIsAdditionalLoad_c19w9lkg";
export const cssButtonIsActive = "cssButtonIsActive_clduka";
export const cssButtonNav = "cssButtonNav_c3yfn5s";
export const cssButtonPage = "cssButtonPage_c1or0mpf";
export const PaginatorPages = /*#__PURE__*/styled('div')({
  name: "PaginatorPages",
  class: "PaginatorPages_pnztv74"
});
export const PaginatorLoad = /*#__PURE__*/styled('div')({
  name: "PaginatorLoad",
  class: "PaginatorLoad_pxqzlrr"
});
export const StyledPaginator = /*#__PURE__*/styled('div')({
  name: "StyledPaginator",
  class: "StyledPaginator_s1dk1ggx"
});
export const cssPageHidden = "cssPageHidden_cz9ssqw";

require("./StyledPaginator.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledPaginator.tsx");